import React from 'react'
import PropTypes from 'prop-types'

function Card({
    component: Component,
    className,
    ...other
}) {
    // Location prop somehow causes an error when its passed into this component.
    return <Component className={className} {...other} />
}

Card.propTypes = {
    /**
   * @ignore
   */
    component: PropTypes.string,
    className: PropTypes.string,
}

Card.defaultProps = {
    component: 'div',
    className: '',
}

export default Card
